export default __webpack_public_path__ + "static/media/csoon-11.27e7dd4a.png";